import React, { createContext, useContext, useState } from 'react';

// Create the context
const DocumentsContext = createContext();

// Create a provider component
export const DocumentsProvider = ({ children }) => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const addDocument = (newDoc) => {
    setDocuments([...documents, newDoc]);
  };

  const removeDocument = (id) => {
    setDocuments(documents.filter((doc) => doc.id !== id));
  };

  return (
    <DocumentsContext.Provider value={{ documents, addDocument, removeDocument, loading, error }}>
      {children}
    </DocumentsContext.Provider>
  );
};

// Custom hook to use the Documents context
export const useDocuments = () => {
  const context = useContext(DocumentsContext);
  if (context === undefined) {
    throw new Error('useDocuments must be used within a DocumentsProvider');
  }
  return context;
};

